import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import CloseButton from 'ext-ui/components/CloseButton/CloseButton'
import React from 'react'
import { ImageNames } from 'src/enums'
import { useFlyoutDispatch } from 'src/hooks'
import { useColorOrGrayscaleImage } from 'src/hooks/brandHooks'
import { useTranslate } from 'src/localization/Trns'
import { closeModal } from 'src/navigation/Lnk'
import { css } from 'styled-components'

interface ExpenseFlyoutHeaderProps {
  reportName: string | undefined
  flyoutTitle: string
}

const ExpenseFlyoutHeader: React.FC<ExpenseFlyoutHeaderProps> = (
  props,
): React.ReactElement => {
  const translate = useTranslate()

  const dispatch = useFlyoutDispatch()
  const addExpense = useColorOrGrayscaleImage(ImageNames.AddExpense)

  return (
    <div
      css={css`
        position: relative;
        padding: 30px 48px;
        background-color: ${styleConstants.colors.white};
        display: flex;
        flex-direction: column;
        border-bottom: 1px solid ${styleConstants.colors.gray_medium};
        flex-shrink: 0;
      `}
    >
      <CloseButton
        css={css`
          flex-shrink: 0;
        `}
        variant="dark-on-light"
        onClick={(): void => {
          dispatch(closeModal())
        }}
      />
      <img
        css={css`
          transform: scale(0.8);
          position: absolute;
          top: -24px;
          right: -16px;
          width: 120px;
          ${getBreakpointDown(breakpointSizes.XSM)(css`
            display: none;
          `)}
        `}
        src={addExpense}
        alt={''}
      />
      <div
        css={css`
          display: flex;
          flex-direction: column;
        `}
      >
        <span
          css={css`
            ${getFontCss(
              32,
              themeConstants.colors.font_primary,
              styleConstants.fontFamilies.medium,
            )};
            margin-top: 50px;
          `}
        >
          {translate(props.flyoutTitle)}
        </span>
        <span
          css={css`
            ${getFontCss(
              20,
              styleConstants.colors.gray_darkest,
              styleConstants.fontFamilies.regular,
            )};
            margin-top: 10px;
          `}
        >
          {props.reportName}
        </span>
      </div>
    </div>
  )
}

export default ExpenseFlyoutHeader
